import { render, staticRenderFns } from "./CardGrid.vue?vue&type=template&id=6c351296&lang=pug&"
import script from "./CardGrid.vue?vue&type=script&lang=ts&"
export * from "./CardGrid.vue?vue&type=script&lang=ts&"
import style0 from "./CardGrid.vue?vue&type=style&index=0&id=6c351296&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports